import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import dayjs from "dayjs"

function useEmployeeWorkInTimestamp() {
  const dispatch = useDispatch();
  const params = useParams();
  const [isModalOpen, setModalOpen] = useState(false);

  // const [dataDetail, setDataDetail] = useState(undefined);
  const isLoading = useSelector((state) => state.employee.isLoading);
  const currentCompany = useSelector((state) => state.company.currentCompany);
  const currentEmployee = useSelector((state) => state.company.currentEmployee);
  const [startDate, setStartDate] = useState(dayjs().startOf("month"))
  const [endDate, setEndDate] = useState(dayjs())
  const [selectedDates, setSelectedDates] = useState(null);

  const handleDateChange = (dates) => {
    setSelectedDates(dates);
  };

  const handleApply = () => {
    // if (selectedDates && selectedDates.length === 2) {
    //   getWorkInList({
    //     startDate: selectedDates[0].format("YYYY-MM-DD"),
    //     endDate: selectedDates[1].format("YYYY-MM-DD")
    //   });
    // }
  };

  const onCreate = useCallback(() => {
    // setCurrentYearAccumulate({});
    setModalOpen(true);
    // setDataDetail(undefined);
  }, []);

  const onCancel = useCallback(() => {
    // setCurrentYearAccumulate({});
    setModalOpen(false);
  }, []);
  return {
    isLoading,

    isModalOpen,
    // initialValues,

    // onEdit,
    onCreate,
    // onSubmit,
    onCancel,
    // onDelete,
    handleDateChange,
    handleApply
  };
}

export default useEmployeeWorkInTimestamp;
